import { C as Component } from "./component-BFVg3Q7H.js";
import { d as defineCustomElement } from "./utilities-BToXpjgA.js";
class DeferredMedia extends Component {
  requiredRefs = ["template"];
  connectedCallback() {
    super.connectedCallback();
    if (this.hasAttribute("data-autoload")) {
      this.showDeferredMedia();
    }
  }
  disconnectedCallback() {
    super.disconnectedCallback();
  }
  showDeferredMedia() {
    if (this.getAttribute("loaded") === "true") {
      return;
    }
    this.setAttribute("loaded", "true");
    const content = this.refs.template.content;
    const firstChild = content.firstElementChild;
    if (firstChild) {
      this.appendChild(firstChild.cloneNode(true));
    }
    this.refs.poster?.remove();
  }
}
defineCustomElement("deferred-media", DeferredMedia);
